import { StyledNewTabIcon } from "@/react/components/styled/StyledIcons";
import { FloatingContainer } from "@/react/features/globalization/FloatingContainer";
import { Button } from "@/react/styled";

const openTap = () => {
  window.open(window.location.href, "_blank", "noreferrer");
};

export function IframeFAB() {
  return (
    <FloatingContainer>
      <Button onClick={openTap}>
        <StyledNewTabIcon size={20} /> Open in TAP
      </Button>
    </FloatingContainer>
  );
}
